function getClassNames(element: HTMLElement): string[] {
  // TODO: consider using element.classNames
  const classes = element.getAttribute('class');
  return classes ? classes.split(' ') : [];
}

/**
 * Adds class if does not exist
 * @param element
 * @param name
 */
function addClassName(element: HTMLElement, name: string) {
  const classes = getClassNames(element);
  if (classes.indexOf(name) === -1) {
    element.setAttribute('class', [...classes, name].join(' '));
  }
}

/**
 * Removes class if exists
 * @param element
 * @param name
 */
function removeClassName(element: HTMLElement, name: string) {
  const classes = getClassNames(element);
  const found = classes.indexOf(name);
  if (found > -1) {
    classes.splice(found, 1);
    element.setAttribute('class', classes.join(' '));
  }
}

function hasClassName(element: HTMLElement, name: string): boolean {
  return getClassNames(element).indexOf(name) > -1;
}

function findAncestor(
  element: HTMLElement | null,
  name: string
): HTMLElement | null {
  while (element && !element.classList.contains(name)) {
    element = element.parentElement;
  }
  return element;
}

export const classAttr = {
  add: addClassName,
  findAncestor,
  has: hasClassName,
  remove: removeClassName
};
